import { TourId } from 'webapp/enums/tour';
import { UserSettingsKey } from 'webapp/enums/user-settings';

import TourBase from 'webapp/models-custom/tour';

export default class WhiteLabelingPayingCustomersPromoTour extends TourBase {
	static keyForPersistantDone = UserSettingsKey.WHITE_LABELING_PAYING_CUSTOMERS_PROMO;
	popupName = '';

	get id(): string {
		return TourId.WHITE_LABELING_PAYING_CUSTOMERS_PROMO;
	}

	override get keyForPersistantDone(): string {
		return WhiteLabelingPayingCustomersPromoTour.keyForPersistantDone;
	}

	override start(): void {
		// Unused, since we only trigger `markDone` when all criteria is met.
	}
}
